import * as React from 'react';

function SvgSmartContracts(props) {
  return (
    <svg width={207} height={205} fill="none" viewBox="0 0 207 205" {...props}>
      <path
        fill="#30CB87"
        d="M147.858 43.3616L162.641 51.8733L147.858 60.3867V60.3884L133.071 51.8733L147.858 43.3616Z"
      />
      <path fill="#1F624A" d="M147.858 77.4135V60.3867L162.641 51.8733L162.643 68.9017L147.858 77.4135Z" />
      <path fill="#B0F2DC" d="M133.071 68.9017L133.073 51.8733L147.858 60.3883V77.4135L133.071 68.9017Z" />
      <path
        fill="#30CB87"
        d="M133.072 136.881L147.856 145.393L133.072 153.906V153.908L118.286 145.393L133.072 136.881Z"
      />
      <path fill="#1F624A" d="M133.072 170.933V153.906L147.856 145.393L147.857 162.421L133.072 170.933Z" />
      <path fill="#B0F2DC" d="M118.286 162.421L118.287 145.393L133.072 153.908V170.933L118.286 162.421Z" />
      <path
        fill="#30CB87"
        d="M162.644 153.885L177.427 162.397L162.644 170.91V170.912L147.857 162.397L162.644 153.885Z"
      />
      <path fill="#1F624A" d="M162.644 187.937V170.91L177.427 162.396L177.429 179.425L162.644 187.937Z" />
      <path fill="#B0F2DC" d="M147.857 179.425L147.859 162.396L162.644 170.912V187.937L147.857 179.425Z" />
      <path
        fill="#30CB87"
        d="M133.072 119.878L147.856 128.389L133.072 136.903V136.904L118.286 128.389L133.072 119.878Z"
      />
      <path fill="#1F624A" d="M133.072 153.93V136.903L147.856 128.389L147.857 145.418L133.072 153.93Z" />
      <path fill="#B0F2DC" d="M118.286 145.418L118.287 128.389L133.072 136.904V153.93L118.286 145.418Z" />
      <path fill="#30CB87" d="M118.287 128.379L133.07 136.891L118.287 145.405V145.406L103.5 136.891L118.287 128.379Z" />
      <path fill="#1F624A" d="M118.287 162.432V145.405L133.07 136.891L133.071 153.92L118.287 162.432Z" />
      <path fill="#B0F2DC" d="M103.5 153.92L103.502 136.891L118.287 145.406V162.432L103.5 153.92Z" />
      <path fill="#30CB87" d="M177.429 60.3652L192.213 68.877L177.429 77.3904V77.392L162.643 68.877L177.429 60.3652Z" />
      <path fill="#1F624A" d="M177.429 94.4174V77.3906L192.213 68.8772L192.214 85.9056L177.429 94.4174Z" />
      <path fill="#B0F2DC" d="M162.643 85.9056L162.644 68.8772L177.429 77.3922V94.4174L162.643 85.9056Z" />
      <path
        fill="#30CB87"
        d="M192.215 34.8596L206.998 43.3714L192.215 51.8848V51.8864L177.429 43.3714L192.215 34.8596Z"
      />
      <path fill="#1F624A" d="M192.215 68.9115V51.8847L206.998 43.3713L207 60.3998L192.215 68.9115Z" />
      <path fill="#B0F2DC" d="M177.429 60.3998L177.43 43.3713L192.215 51.8864V68.9115L177.429 60.3998Z" />
      <path
        fill="#30CB87"
        d="M147.858 26.3579L162.641 34.8697L147.858 43.3831V43.3847L133.071 34.8697L147.858 26.3579Z"
      />
      <path fill="#1F624A" d="M147.858 60.4096V43.3828L162.641 34.8694L162.643 51.8978L147.858 60.4096Z" />
      <path fill="#B0F2DC" d="M133.071 51.8978L133.073 34.8694L147.858 43.3844V60.4096L133.071 51.8978Z" />
      <path
        fill="#30CB87"
        d="M177.429 111.376L192.213 119.887L177.429 128.401V128.403L162.643 119.887L177.429 111.376Z"
      />
      <path fill="#1F624A" d="M177.429 145.427V128.401L192.213 119.887L192.214 136.916L177.429 145.427Z" />
      <path fill="#B0F2DC" d="M162.643 136.916L162.644 119.887L177.429 128.402V145.427L162.643 136.916Z" />
      <path
        fill="#30CB87"
        d="M103.501 136.881L118.284 145.393L103.501 153.906V153.908L88.7143 145.393L103.501 136.881Z"
      />
      <path fill="#1F624A" d="M103.501 170.933V153.906L118.284 145.393L118.286 162.421L103.501 170.933Z" />
      <path fill="#B0F2DC" d="M88.7143 162.421L88.7159 145.393L103.501 153.908V170.933L88.7143 162.421Z" />
      <path fill="#30CB87" d="M103.501 170.888L118.284 179.4L103.501 187.914V187.915L88.7143 179.4L103.501 170.888Z" />
      <path fill="#1F624A" d="M103.501 204.94V187.914L118.284 179.4L118.286 196.429L103.501 204.94Z" />
      <path fill="#B0F2DC" d="M88.7143 196.429L88.7159 179.4L103.501 187.915V204.94L88.7143 196.429Z" />
      <path
        fill="#30CB87"
        d="M88.7151 162.386L103.498 170.898L88.7151 179.412V179.413L73.9286 170.898L88.7151 162.386Z"
      />
      <path fill="#1F624A" d="M88.7151 196.438V179.412L103.498 170.898L103.5 187.927L88.7151 196.438Z" />
      <path fill="#B0F2DC" d="M73.9286 187.927L73.9302 170.898L88.7151 179.413V196.438L73.9286 187.927Z" />
      <path
        fill="#30CB87"
        d="M88.7151 145.383L103.498 153.895L88.7151 162.408V162.41L73.9286 153.895L88.7151 145.383Z"
      />
      <path fill="#1F624A" d="M88.7151 179.435V162.408L103.498 153.895L103.5 170.923L88.7151 179.435Z" />
      <path fill="#B0F2DC" d="M73.9286 170.923L73.9302 153.895L88.7151 162.41V179.435L73.9286 170.923Z" />
      <path
        fill="#30CB87"
        d="M162.644 102.874L177.427 111.386L162.644 119.899V119.901L147.857 111.386L162.644 102.874Z"
      />
      <path fill="#1F624A" d="M162.644 136.926V119.899L177.427 111.386L177.429 128.414L162.644 136.926Z" />
      <path fill="#B0F2DC" d="M147.857 128.414L147.859 111.386L162.644 119.901V136.926L147.857 128.414Z" />
      <path
        fill="#30CB87"
        d="M103.501 119.878L118.284 128.389L103.501 136.903V136.904L88.7143 128.389L103.501 119.878Z"
      />
      <path fill="#1F624A" d="M103.501 153.93V136.903L118.284 128.389L118.286 145.418L103.501 153.93Z" />
      <path fill="#B0F2DC" d="M88.7143 145.418L88.7159 128.389L103.501 136.904V153.93L88.7143 145.418Z" />
      <path
        fill="#30CB87"
        d="M162.644 85.8704L177.427 94.3821L162.644 102.896V102.897L147.857 94.3821L162.644 85.8704Z"
      />
      <path fill="#1F624A" d="M162.644 119.922V102.895L177.427 94.3821L177.429 111.41L162.644 119.922Z" />
      <path fill="#B0F2DC" d="M147.857 111.41L147.859 94.3821L162.644 102.897V119.922L147.857 111.41Z" />
      <path
        fill="#30CB87"
        d="M147.858 94.3723L162.641 102.884L147.858 111.397V111.399L133.071 102.884L147.858 94.3723Z"
      />
      <path fill="#1F624A" d="M147.858 128.424V111.397L162.641 102.884L162.643 119.912L147.858 128.424Z" />
      <path fill="#B0F2DC" d="M133.071 119.912L133.073 102.884L147.858 111.399V128.424L133.071 119.912Z" />
      <path
        fill="#30CB87"
        d="M162.644 0.852539L177.427 9.36431L162.644 17.8777V17.8793L147.857 9.36431L162.644 0.852539Z"
      />
      <path fill="#1F624A" d="M162.644 34.9047V17.8779L177.427 9.3645L177.429 26.3929L162.644 34.9047Z" />
      <path fill="#B0F2DC" d="M147.857 26.3929L147.859 9.3645L162.644 17.8795V34.9047L147.857 26.3929Z" />
      <path
        fill="#30CB87"
        d="M147.858 77.3687L162.641 85.8804L147.858 94.3938V94.3954L133.071 85.8804L147.858 77.3687Z"
      />
      <path fill="#1F624A" d="M147.858 111.421V94.394L162.641 85.8806L162.643 102.909L147.858 111.421Z" />
      <path fill="#B0F2DC" d="M133.071 102.909L133.073 85.8806L147.858 94.3956V111.421L133.071 102.909Z" />
      <path
        fill="#30CB87"
        d="M133.072 85.8704L147.856 94.3821L133.072 102.896V102.897L118.286 94.3821L133.072 85.8704Z"
      />
      <path fill="#1F624A" d="M133.072 119.922V102.895L147.856 94.3821L147.857 111.41L133.072 119.922Z" />
      <path fill="#B0F2DC" d="M118.286 111.41L118.287 94.3821L133.072 102.897V119.922L118.286 111.41Z" />
      <path fill="#30CB87" d="M118.287 94.3723L133.07 102.884L118.287 111.397V111.399L103.5 102.884L118.287 94.3723Z" />
      <path fill="#1F624A" d="M118.287 128.424V111.397L133.07 102.884L133.071 119.912L118.287 128.424Z" />
      <path fill="#B0F2DC" d="M103.5 119.912L103.502 102.884L118.287 111.399V128.424L103.5 119.912Z" />
      <path
        fill="#30CB87"
        d="M133.072 68.8667L147.856 77.3785L133.072 85.8919V85.8935L118.286 77.3785L133.072 68.8667Z"
      />
      <path fill="#1F624A" d="M133.072 102.919V85.8923L147.856 77.3789L147.857 94.4073L133.072 102.919Z" />
      <path fill="#B0F2DC" d="M118.286 94.4073L118.287 77.3789L133.072 85.8939V102.919L118.286 94.4073Z" />
      <path fill="#30CB87" d="M118.287 77.3687L133.07 85.8804L118.287 94.3938V94.3954L103.5 85.8804L118.287 77.3687Z" />
      <path fill="#1F624A" d="M118.287 111.421V94.394L133.07 85.8806L133.071 102.909L118.287 111.421Z" />
      <path fill="#B0F2DC" d="M103.5 102.909L103.502 85.8806L118.287 94.3956V111.421L103.5 102.909Z" />
      <path
        fill="#30CB87"
        d="M133.072 51.8635L147.856 60.3753L133.072 68.8887V68.8903L118.286 60.3753L133.072 51.8635Z"
      />
      <path fill="#1F624A" d="M133.072 85.9154V68.8886L147.856 60.3752L147.857 77.4037L133.072 85.9154Z" />
      <path fill="#B0F2DC" d="M118.286 77.4037L118.287 60.3752L133.072 68.8903V85.9154L118.286 77.4037Z" />
      <path
        fill="#30CB87"
        d="M133.072 34.8596L147.856 43.3714L133.072 51.8848V51.8864L118.286 43.3714L133.072 34.8596Z"
      />
      <path fill="#1F624A" d="M133.072 68.9115V51.8847L147.856 43.3713L147.857 60.3998L133.072 68.9115Z" />
      <path fill="#B0F2DC" d="M118.286 60.3998L118.287 43.3713L133.072 51.8864V68.9115L118.286 60.3998Z" />
      <path fill="#30CB87" d="M133.072 17.8562L147.856 26.368L133.072 34.8814V34.883L118.286 26.368L133.072 17.8562Z" />
      <path fill="#1F624A" d="M133.072 51.9081V34.8813L147.856 26.3679L147.857 43.3963L133.072 51.9081Z" />
      <path fill="#B0F2DC" d="M118.286 43.3963L118.287 26.3679L133.072 34.8829V51.9081L118.286 43.3963Z" />
      <path fill="#30CB87" d="M118.287 26.3579L133.07 34.8697L118.287 43.3831V43.3847L103.5 34.8697L118.287 26.3579Z" />
      <path fill="#1F624A" d="M118.287 60.4096V43.3828L133.07 34.8694L133.071 51.8978L118.287 60.4096Z" />
      <path fill="#B0F2DC" d="M103.5 51.8978L103.502 34.8694L118.287 43.3844V60.4096L103.5 51.8978Z" />
      <path
        fill="#30CB87"
        d="M133.072 0.852539L147.856 9.36431L133.072 17.8777V17.8793L118.286 9.36431L133.072 0.852539Z"
      />
      <path fill="#1F624A" d="M133.072 34.9047V17.8779L147.856 9.3645L147.857 26.3929L133.072 34.9047Z" />
      <path fill="#B0F2DC" d="M118.286 26.3929L118.287 9.3645L133.072 17.8795V34.9047L118.286 26.3929Z" />
      <path
        fill="#30CB87"
        d="M103.501 102.874L118.284 111.386L103.501 119.899V119.901L88.7143 111.386L103.501 102.874Z"
      />
      <path fill="#1F624A" d="M103.501 136.926V119.899L118.284 111.386L118.286 128.414L103.501 136.926Z" />
      <path fill="#B0F2DC" d="M88.7143 128.414L88.7159 111.386L103.501 119.901V136.926L88.7143 128.414Z" />
      <path
        fill="#30CB87"
        d="M103.501 85.8704L118.284 94.3821L103.501 102.896V102.897L88.7143 94.3821L103.501 85.8704Z"
      />
      <path fill="#1F624A" d="M103.501 119.922V102.895L118.284 94.3821L118.286 111.41L103.501 119.922Z" />
      <path fill="#B0F2DC" d="M88.7143 111.41L88.7159 94.3821L103.501 102.897V119.922L88.7143 111.41Z" />
      <path fill="#30CB87" d="M118.287 60.3652L133.07 68.877L118.287 77.3904V77.392L103.5 68.877L118.287 60.3652Z" />
      <path fill="#1F624A" d="M118.287 94.4174V77.3906L133.07 68.8772L133.071 85.9056L118.287 94.4174Z" />
      <path fill="#B0F2DC" d="M103.5 85.9056L103.502 68.8772L118.287 77.3922V94.4174L103.5 85.9056Z" />
      <path
        fill="#30CB87"
        d="M88.7151 128.379L103.498 136.891L88.7151 145.405V145.406L73.9286 136.891L88.7151 128.379Z"
      />
      <path fill="#1F624A" d="M88.7151 162.432V145.405L103.498 136.891L103.5 153.92L88.7151 162.432Z" />
      <path fill="#B0F2DC" d="M73.9286 153.92L73.9302 136.891L88.7151 145.406V162.432L73.9286 153.92Z" />
      <path
        fill="#30CB87"
        d="M88.7151 111.376L103.498 119.887L88.7151 128.401V128.403L73.9286 119.887L88.7151 111.376Z"
      />
      <path fill="#1F624A" d="M88.7151 145.427V128.401L103.498 119.887L103.5 136.916L88.7151 145.427Z" />
      <path fill="#B0F2DC" d="M73.9286 136.916L73.9302 119.887L88.7151 128.402V145.427L73.9286 136.916Z" />
      <path
        fill="#30CB87"
        d="M88.7151 94.3723L103.498 102.884L88.7151 111.397V111.399L73.9286 102.884L88.7151 94.3723Z"
      />
      <path fill="#1F624A" d="M88.7151 128.424V111.397L103.498 102.884L103.5 119.912L88.7151 128.424Z" />
      <path fill="#B0F2DC" d="M73.9286 119.912L73.9302 102.884L88.7151 111.399V128.424L73.9286 119.912Z" />
      <path
        fill="#30CB87"
        d="M73.9294 136.881L88.7127 145.393L73.9294 153.906V153.908L59.1429 145.393L73.9294 136.881Z"
      />
      <path fill="#1F624A" d="M73.9294 170.933V153.906L88.7126 145.393L88.7143 162.421L73.9294 170.933Z" />
      <path fill="#B0F2DC" d="M59.1429 162.421L59.1445 145.393L73.9294 153.908V170.933L59.1429 162.421Z" />
      <path
        fill="#30CB87"
        d="M59.1437 162.386L73.9269 170.898L59.1437 179.412V179.413L44.3571 170.898L59.1437 162.386Z"
      />
      <path fill="#1F624A" d="M59.1437 196.438V179.412L73.9269 170.898L73.9286 187.927L59.1437 196.438Z" />
      <path fill="#B0F2DC" d="M44.3571 187.927L44.3588 170.898L59.1437 179.413V196.438L44.3571 187.927Z" />
      <path
        fill="#30CB87"
        d="M73.9294 119.878L88.7127 128.389L73.9294 136.903V136.904L59.1429 128.389L73.9294 119.878Z"
      />
      <path fill="#1F624A" d="M73.9294 153.93V136.903L88.7126 128.389L88.7143 145.418L73.9294 153.93Z" />
      <path fill="#B0F2DC" d="M59.1429 145.418L59.1445 128.389L73.9294 136.904V153.93L59.1429 145.418Z" />
      <path
        fill="#30CB87"
        d="M59.1437 128.379L73.9269 136.891L59.1437 145.405V145.406L44.3571 136.891L59.1437 128.379Z"
      />
      <path fill="#1F624A" d="M59.1437 162.432V145.405L73.9269 136.891L73.9286 153.92L59.1437 162.432Z" />
      <path fill="#B0F2DC" d="M44.3571 153.92L44.3588 136.891L59.1437 145.406V162.432L44.3571 153.92Z" />
      <path fill="#30CB87" d="M14.7865 170.888L29.5698 179.4L14.7865 187.914V187.915L0 179.4L14.7865 170.888Z" />
      <path fill="#1F624A" d="M14.7865 204.94V187.914L29.5698 179.4L29.5714 196.429L14.7865 204.94Z" />
      <path fill="#B0F2DC" d="M0 196.429L0.00163261 179.4L14.7865 187.915V204.94L0 196.429Z" />
      <path
        fill="#30CB87"
        d="M59.1437 111.376L73.9269 119.887L59.1437 128.401V128.403L44.3571 119.887L59.1437 111.376Z"
      />
      <path fill="#1F624A" d="M59.1437 145.427V128.401L73.9269 119.887L73.9286 136.916L59.1437 145.427Z" />
      <path fill="#B0F2DC" d="M44.3571 136.916L44.3588 119.887L59.1437 128.402V145.427L44.3571 136.916Z" />
      <path
        fill="#30CB87"
        d="M59.1437 94.3723L73.9269 102.884L59.1437 111.397V111.399L44.3571 102.884L59.1437 94.3723Z"
      />
      <path fill="#1F624A" d="M59.1437 128.424V111.397L73.9269 102.884L73.9286 119.912L59.1437 128.424Z" />
      <path fill="#B0F2DC" d="M44.3571 119.912L44.3588 102.884L59.1437 111.399V128.424L44.3571 119.912Z" />
      <path fill="#30CB87" d="M44.358 102.874L59.1412 111.386L44.358 119.899V119.901L29.5714 111.386L44.358 102.874Z" />
      <path fill="#1F624A" d="M44.358 136.926V119.899L59.1412 111.386L59.1429 128.414L44.358 136.926Z" />
      <path fill="#B0F2DC" d="M29.5714 128.414L29.5731 111.386L44.358 119.901V136.926L29.5714 128.414Z" />
      <path fill="#30CB87" d="M44.358 85.8704L59.1412 94.3821L44.358 102.896V102.897L29.5714 94.3821L44.358 85.8704Z" />
      <path fill="#1F624A" d="M44.358 119.922V102.895L59.1412 94.3821L59.1429 111.41L44.358 119.922Z" />
      <path fill="#B0F2DC" d="M29.5714 111.41L29.5731 94.3821L44.358 102.897V119.922L29.5714 111.41Z" />
      <path fill="#30CB87" d="M44.358 119.878L59.1412 128.389L44.358 136.903V136.904L29.5714 128.389L44.358 119.878Z" />
      <path fill="#1F624A" d="M44.358 153.93V136.903L59.1412 128.389L59.1429 145.418L44.358 153.93Z" />
      <path fill="#B0F2DC" d="M29.5714 145.418L29.5731 128.389L44.358 136.904V153.93L29.5714 145.418Z" />
      <path fill="#30CB87" d="M118.287 94.3723L133.07 102.884L118.287 111.397V111.399L103.5 102.884L118.287 94.3723Z" />
      <path fill="#1F624A" d="M118.287 128.424V111.397L133.07 102.884L133.071 119.912L118.287 128.424Z" />
      <path fill="#B0F2DC" d="M103.5 119.912L103.502 102.884L118.287 111.399V128.424L103.5 119.912Z" />
      <path
        fill="#30CB87"
        d="M103.501 68.8667L118.284 77.3785L103.501 85.8919V85.8935L88.7143 77.3785L103.501 68.8667Z"
      />
      <path fill="#1F624A" d="M103.501 102.919V85.8923L118.284 77.3789L118.286 94.4073L103.501 102.919Z" />
      <path fill="#B0F2DC" d="M88.7143 94.4073L88.7159 77.3789L103.501 85.8939V102.919L88.7143 94.4073Z" />
      <path
        fill="#30CB87"
        d="M103.501 51.8635L118.284 60.3753L103.501 68.8887V68.8903L88.7143 60.3753L103.501 51.8635Z"
      />
      <path fill="#1F624A" d="M103.501 85.9154V68.8886L118.284 60.3752L118.286 77.4037L103.501 85.9154Z" />
      <path fill="#B0F2DC" d="M88.7143 77.4037L88.7159 60.3752L103.501 68.8903V85.9154L88.7143 77.4037Z" />
      <path
        fill="#30CB87"
        d="M88.7151 77.3687L103.498 85.8804L88.7151 94.3938V94.3954L73.9286 85.8804L88.7151 77.3687Z"
      />
      <path fill="#1F624A" d="M88.7151 111.421V94.394L103.498 85.8806L103.5 102.909L88.7151 111.421Z" />
      <path fill="#B0F2DC" d="M73.9286 102.909L73.9302 85.8806L88.7151 94.3956V111.421L73.9286 102.909Z" />
      <path
        fill="#30CB87"
        d="M177.429 77.3687L192.213 85.8804L177.429 94.3938V94.3954L162.643 85.8804L177.429 77.3687Z"
      />
      <path fill="#1F624A" d="M177.429 111.421V94.394L192.213 85.8806L192.214 102.909L177.429 111.421Z" />
      <path fill="#B0F2DC" d="M162.643 102.909L162.644 85.8806L177.429 94.3956V111.421L162.643 102.909Z" />
      <path fill="#30CB87" d="M88.7151 60.3652L103.498 68.877L88.7151 77.3904V77.392L73.9286 68.877L88.7151 60.3652Z" />
      <path fill="#1F624A" d="M88.7151 94.4174V77.3906L103.498 68.8772L103.5 85.9056L88.7151 94.4174Z" />
      <path fill="#B0F2DC" d="M73.9286 85.9056L73.9302 68.8772L88.7151 77.3922V94.4174L73.9286 85.9056Z" />
      <path
        fill="#30CB87"
        d="M73.9294 68.8667L88.7127 77.3785L73.9294 85.8919V85.8935L59.1429 77.3785L73.9294 68.8667Z"
      />
      <path fill="#1F624A" d="M73.9294 102.919V85.8923L88.7126 77.3789L88.7143 94.4073L73.9294 102.919Z" />
      <path fill="#B0F2DC" d="M59.1429 94.4073L59.1445 77.3789L73.9294 85.8939V102.919L59.1429 94.4073Z" />
      <path
        fill="#30CB87"
        d="M73.9294 51.8635L88.7127 60.3753L73.9294 68.8887V68.8903L59.1429 60.3753L73.9294 51.8635Z"
      />
      <path fill="#1F624A" d="M73.9294 85.9154V68.8886L88.7126 60.3752L88.7143 77.4037L73.9294 85.9154Z" />
      <path fill="#B0F2DC" d="M59.1429 77.4037L59.1445 60.3752L73.9294 68.8903V85.9154L59.1429 77.4037Z" />
      <path
        fill="#30CB87"
        d="M59.1437 43.3616L73.9269 51.8733L59.1437 60.3867V60.3884L44.3571 51.8733L59.1437 43.3616Z"
      />
      <path fill="#1F624A" d="M59.1437 77.4135V60.3867L73.9269 51.8733L73.9286 68.9017L59.1437 77.4135Z" />
      <path fill="#B0F2DC" d="M44.3571 68.9017L44.3588 51.8733L59.1437 60.3883V77.4135L44.3571 68.9017Z" />
    </svg>
  );
}

export default SvgSmartContracts;
